import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import { v4 as uuidv4 } from "uuid";
import {
  getPurchaseInvoice,
  getPurchaseInvoiceById,
  getParticularPage,
  getPurchaseOrderDetail,
  getNext,
  getPrevious,
  handleSearch,
  createPurchaseInvoice,
  getPurchaseInvoiceAdditionalChargeList,
} from "./thunk";
import { NepaliDate } from "@zener/nepali-datepicker-react";
import { dateFormater } from "../../../../../../Utils/dateFormater";

const initialState = {
  purchaseInvoices: [],
  edit: false,
  purchaseInvoice: null,
  count: 0,
  pageNo: 1,
  next: null,
  previous: null,
  loading: false,
  loadingCreate: false,
  loadingUpdated: false,
  loadingPurchaseInvoice: false,
  loadingNext: false,
  loadingDetails: false,
  saveAndContinue: false,
  purchaseInvoiceDetails: [
    {
      unique: uuidv4(),
      product: null,
      quantity: 0,
      rate: 0,
      amount: 0,
      unit: null,
      altQuantity: 0,
      actualQuantity: 0,
    },
  ],
  additionalCharges: [],
  showCreateModal: false,
  selectedPurchaseInvoice: null,
  selectedPurchaseInvoiceDetails: [],
  selectedAdditionalCharges: [],
  formData: {
    purchaseOrderMain: null,
    invoiceNo: "",

    purchaseFromBranch: null,

    branch: null,
    partyAccount: null,
    refNo: null,
    voucherDateBs: new NepaliDate(),
    narration: "",
    discountAmount: "",
    grandTotal: "",
    vatAmount: "",
    documentsAttach: [],

    purchaseInvoiceMainPartyDetails: {
      // creditDays: "",
      jobNumber: "",
    },
    purchaseInvoiceMainVehicleDetail: {
      vehicleNo: "",
      builtyNo: "",
      driverName: "",
      driverPhoneNo: "",
      driverAddress: "",
      licenseNo: "",
      transporter: "",
      quantity: "",
    },
  },
};

export const purchaseInvoiceSlice = createSlice({
  name: "purchaseInvoice",
  initialState,
  reducers: {
    setShowCreateModal: (state, action) => {
      state.showCreateModal = action.payload;
    },
    setSaveAndContinue: (state, { payload }) => {
      state.saveAndContinue = payload;
    },
    goToPage: (state, { payload }) => {
      state.pageNo = payload;
    },

    setMainOrder: (state, action) => {
      state.selectedPurchaseInvoice = action.payload;
    },
    setOrderDetails: (state, action) => {
      state.selectedPurchaseInvoiceDetails = action.payload.map((value) => ({
        ...value,
        description: value.product?.name || "",
      }));
    },
    setAdditionalDetails: (state, action) => {
      state.selectedAdditionalCharges = action.payload.map((value) => {
        return { ...value, unique: uuidv4() };
      });
    },
    updatedAdditionalCharges: (state, action) => {
      state.additionalCharges = action.payload;
    },
    // setPurchaseInvoice: (state, action) => {
    //   state.purchaseInvoice = action.payload;
    // },
    setAdditionalCharges: (state, action) => {
      state.additionalCharges = action.payload;
    },
    setPurchaseInvoiceDetails: (state, action) => {
      state.purchaseInvoiceDetails = [
        ...action.payload,
        {
          unique: uuidv4(),
          product: null,
          quantity: 0,
          rate: 0,
          amount: 0,
          unit: null,
          altQuantity: 0,
          actualQuantity: 0,
        },
      ];
    },
    purchaseInvoiceDetailsUpdated: (state, action) => {
      state.purchaseInvoiceDetails = action.payload;
    },
    clearSelectedOrderData: (state) => {
      state.selectedPurchaseInvoice = null;
      state.selectedPurchaseInvoiceDetails = [];
      state.selectedAdditionalCharges = [];
    },
    clearPurchaseInvoiceDetails: (state, action) => {
      state.purchaseInvoiceDetails = [
        {
          unique: uuidv4(),
          product: null,
          quantity: 0,
          rate: 0,
          amount: 0,
          unit: null,
          altQuantity: 0,
          actualQuantity: 0,
          requiredDate: dateFormater(new NepaliDate()),
        },
      ];
      state.additionalCharges = [];
    },

    clearPurchaseInvoiceDetails: (state) => {
      state.purchaseInvoiceDetails = [
        {
          unique: uuidv4(),
          product: null,
          quantity: 0,
          rate: 0,
          amount: 0,
          unit: null,
          altQuantity: 0,
          actualQuantity: 0,
          requiredDate: dateFormater(new NepaliDate()),
        },
      ];
    },
    clearAllPurchaseInvoice: (state) => {
      state.edit = false;
      state.loading = false;
      state.loadingUpdated = false;
      state.loadingPurchaseInvoice = false;
      state.purchaseInvoice = null;
      state.selectedPurchaseInvoice = null;
      state.selectedPurchaseInvoiceDetails = [];
      state.selectedAdditionalCharges = [];
      state.purchaseInvoiceDetails = [
        {
          unique: uuidv4(),
          product: null,
          quantity: 0,
          rate: 0,
          amount: 0,
          unit: null,
          altQuantity: 0,
          actualQuantity: 0,
          requiredDate: dateFormater(new NepaliDate()),
        },
      ];
      // state.additionalCharges = null;
      state.saveAndContinue = false;
      state.formData = initialState.formData;
    },

    savePurchaseInvoiceForm: (state, action) => {
      state.formData = action.payload;
    },
    resetPurchaseInvoiceForm: (state, action) => {
      if (action.payload) {
        state.formData = state.purchaseOrder;
      } else {
        state.formData = initialState.formData;
        state.purchaseInvoice = initialState.purchaseInvoice;
        state.purchaseInvoiceDetails = initialState.purchaseInvoiceDetails;
        state.additionalCharges = initialState.additionalCharges;
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getPurchaseInvoiceAdditionalChargeList.pending, (state) => {
      state.additionalCharges = null;
    });
    builder.addCase(getPurchaseInvoiceAdditionalChargeList.fulfilled, (state, action) => {
      state.additionalCharges = action.payload.data;
    });
    builder.addCase(getPurchaseInvoiceAdditionalChargeList.rejected, (state) => {
      state.additionalCharges = null;
    });
    // get
    builder.addCase(createPurchaseInvoice.pending, (state) => {
      state.loadingCreate = true;
    });
    builder.addCase(createPurchaseInvoice.fulfilled, (state, action) => {
      state.loadingCreate = false;
    });
    builder.addCase(createPurchaseInvoice.rejected, (state) => {
      state.loadingCreate = false;
    });
    builder.addCase(getPurchaseOrderDetail.pending, (state) => {
      state.loadingDetails = true;
      // state.purchaseInvoice = null;
      // state.purchaseInvoiceDetails = null;
    });
    builder.addCase(getPurchaseOrderDetail.fulfilled, (state, action) => {
      state.loadingDetails = false;
      // state.purchaseInvoice = action.payload.data;
      // state.purchaseInvoiceDetails = action.payload.data?.goodReceiptNotesDetails;
      // state.additionalCharges = action.payload.data.grnMainAdditionalChargeCost; ///ddddd
    });
    builder.addCase(getPurchaseOrderDetail.rejected, (state) => {
      state.loadingDetails = false;
      // state.purchaseInvoice = null;
      // state.purchaseInvoiceDetails = null;
    });
    // getPurchaseInvoiceById
    builder.addCase(getPurchaseInvoiceById.pending, (state) => {
      state.loading = true;
      state.purchaseInvoice = null;
    });
    builder.addCase(getPurchaseInvoiceById.fulfilled, (state, action) => {
      state.edit = true;
      state.loading = false;
      state.purchaseInvoice = action.payload.data;

      state.purchaseInvoiceDetails = action.payload.data?.purchaseInvoiceDetail.map((value) => {
        return { ...value, unique: uuidv4() };
      });
      state.additionalCharges = action.payload.data.grnMainAdditionalChargeCost; ///ddddd
      state.formData = {
        ...action.payload.data,

        purchaseOrderMain: action.payload.data.purchaseInvoice?.purchaseOrderMain,
        invoiceNo: action.payload.data.purchaseInvoice?.purchaseInvoiceNo,

        purchaseFromBranch: action.payload.data.purchaseInvoice?.purchaseInvoiceFromBranch,
        branch: action.payload.data.purchaseInvoice?.branch,
        partyAccount: action.payload.data.purchaseInvoice?.partyAccount,
        refNo: action.payload.data.purchaseInvoice?.refNo,

        narration: action.payload.data.purchaseInvoice?.purchaseOrderMain.narration,
      }; ///ddddd
    });
    builder.addCase(getPurchaseInvoiceById.rejected, (state) => {
      state.edit = false;
      state.loading = false;
      state.purchaseInvoice = null;
    });
    builder.addMatcher(
      isAnyOf(
        getPurchaseInvoice.pending,
        getParticularPage.pending,
        getPrevious.pending,
        getNext.pending,
        handleSearch.pending
      ),
      (state) => {
        state.loadingPurchaseInvoice = true;
      }
    );

    builder.addMatcher(
      isAnyOf(
        getPurchaseInvoice.fulfilled,
        getParticularPage.fulfilled,
        getPrevious.fulfilled,
        getNext.fulfilled,
        handleSearch.fulfilled
      ),
      (state, action) => {
        state.loadingPurchaseInvoice = false;
        state.purchaseInvoices = action.payload.data;
        state.count = action.payload.totalCount;

        state.previous = action.payload.previous;
        state.next = action.payload.next;
      }
    );
    builder.addMatcher(
      isAnyOf(
        getPurchaseInvoice.rejected,
        getParticularPage.rejected,
        getPrevious.rejected,
        getNext.rejected,
        handleSearch.rejected
      ),
      (state) => {
        state.loadingPurchaseInvoice = false;
      }
    );
  },
});

export const {
  setShowCreateModal,
  setSaveAndContinue,
  goToPage,
  setMainOrder,
  setOrderDetails,
  setAdditionalDetails,
  updatedAdditionalCharges,
  // setPurchaseInvoice,
  setAdditionalCharges,
  setPurchaseInvoiceDetails,
  purchaseInvoiceDetailsUpdated,
  clearSelectedOrderData,
  clearPurchaseInvoiceDetails,
  clearAllPurchaseInvoice,
  savePurchaseInvoiceForm,
  resetPurchaseInvoiceForm,
} = purchaseInvoiceSlice.actions;

export default purchaseInvoiceSlice.reducer;
